<!-- MAIA Step 3 of 4 — Enhancing portfolio data (paid-overlay progress). -->
<div class="maia-enhance-step" data-testid="maia-enhance-step">


    <header class="step-header">
        <div class="step-heading">
            <h1>Enhancing your location data</h1>
            <!-- <p>Enhancing in progress — this usually takes a few minutes.</p>
            <div class="step-meta">Step 3 of 4 · Enrich</div>
            <div class="step-dots">
                <span class="dot"></span><span class="dot"></span>
                <span class="dot active"></span><span class="dot"></span>
            </div> -->
        </div>
    </header>

    <section class="enhance-panel">
        <div class="enhance-title">
            <span class="pulse-dot" aria-hidden="true"></span>
            <span>{{ errorMessage ? 'Enrichment failed' : 'Enhancing in progress…' }}</span>
        </div>

        <p class="enhance-sub" *ngIf="fileName">
            Processing locations from <strong>{{ fileName }}</strong>
        </p>

        <div class="progress-head" *ngIf="!indeterminate">
            <span class="progress-pct">{{ percent }}%</span>
        </div>
        <div class="progress-track">
            <div class="progress-fill" [class.indeterminate]="indeterminate"
                 [style.width.%]="indeterminate ? null : percent"></div>
        </div>

        <div class="enhance-status" *ngIf="!errorMessage">
            <svg class="spinner" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" aria-hidden="true">
                <path d="M21 12a9 9 0 1 1-6.2-8.6"></path>
            </svg>
            <span>{{ statusMessage }}</span>
        </div>
        <p class="enhance-error" *ngIf="errorMessage">{{ errorMessage }}</p>
    </section>
</div>
